import { Card, Empty } from "antd";
import { useTranslation } from "react-i18next";

import AdditionalCosts from "@/components/Project/ProjectAdditionalCosts/AdditionalCosts";
import { useReferentialProjectCostTypes } from "@/entities/referential/referential-project-cost-types";

import ProjectCostsCardContent from "./ProjectCostsCardContent";

import "./ProjectCostsCard.style.less";

const ProjectCostsCard = ({ project, loading }) => {
  const { t } = useTranslation();
  const { isLoading } = useReferentialProjectCostTypes();
  const showLoadingIndicator = loading || isLoading;

  return (
    <Card
      title={t("project:costsCard:title")}
      className="project-costs-card"
      loading={showLoadingIndicator}
      extra={!showLoadingIndicator && <AdditionalCosts project={project} />}
    >
      {project?.id ? <ProjectCostsCardContent project={project} /> : <Empty />}
    </Card>
  );
};

export default ProjectCostsCard;
